module.exports = __webpack_public_path__ + "static/4_2_recommendation-f9b5ba55ce9b7dcbc87dccf692b3ad4b.svg";